type DesktopShortcut = {
  label: string;
  icon: 'folder' | 'document' | 'mail';
  to?: string;
  href?: string;
};

export const desktopShortcuts: DesktopShortcut[] = [
  {
    label: 'Projects',
    icon: 'folder',
    to: '/projects',
  },
  {
    label: 'About.txt',
    icon: 'document',
    to: '/about',
  },
  {
    label: 'Contact',
    icon: 'mail',
    href: 'mailto:hello@jovannimosca.com',
  },
];
